import { darkColors } from '@/theme/colors'

/**
 * Color intention that you want to used in your theme
 * @param {JsonObject} theme Theme customization object
 */
export default function themePalette(theme: { colors: typeof darkColors; customization: Record<string, string> }) {
  return {
    background: {
      default: theme.colors.backgroundDefault,
      paper: theme.colors.paper,
    },
    divider: theme.colors.divider,
    error: {
      contrastText: theme.colors.contrastText,
      main: theme.colors.error,
      light: theme.colors.error,
      dark: theme.colors.error,
    },
    mode: theme.customization?.theme.toLowerCase(),
    primary: {
      contrastText: theme.colors.contrastText,
      main: theme.colors.primary,

      light: theme.colors.primaryLight,
      dark: theme.colors.primaryDark,
    },
    secondary: {
      contrastText: theme.colors.contrastText,
      light: theme.colors.secondaryLight,
      main: theme.colors.textSecondary,
      dark: theme.colors.secondaryDark,
    },
    success: {
      contrastText: theme.colors.contrastText,
      main: theme.colors.success,
      light: theme.colors.success,
      dark: theme.colors.success,
    },
    text: {
      primary: theme.colors.text,
      secondary: theme.colors.textSecondary,
      primaryContrast: theme.colors.textPrimaryContrast,
    },
    warning: {
      contrastText: theme.colors.contrastText,
      main: theme.colors.warning,
    },

    global: {
      yellow: theme.colors.global?.yellow,
      lightGray: theme.colors.global?.lightGray,
      darkBlueGray: theme.colors.global?.darkBlueGray,
      ibBlack: theme.colors.global?.ibBlack,
      lightBlueGray: theme.colors.global?.lightBlueGray,
      dimWhite: theme.colors.global?.dimWhite,
      primaryRed: theme.colors.global?.primaryRed,
    },
    card: {
      main: theme.colors.paper,
    },
    canvasHeader: {
      settingsDropdown: theme.colors.canvasHeader?.buttonBorderPrimary,
      primaryDark: theme.colors.canvasHeader?.primaryDark,
      deployLight: theme.colors.primaryLight,
      deployDark: theme.colors.primaryDark,
      saveLight: theme.colors.secondaryLight,
      saveDark: theme.colors.secondaryDark,
      // settingsLight: theme.colors.grey300,
      // settingsDark: theme.colors.grey700,
    },
    codeEditor: {
      main: theme.colors.backgroundDefault,
    },
    agentBuilder: {
      border: theme.colors.agentBuilder?.dimOutline,
      borderLight: theme.colors.agentChat?.lightGray,
      dimPrimary: theme.colors.agentBuilder?.dimPrimary,
      divider: theme.colors.agentBuilder?.divider,
      label: theme.colors.agentBuilder?.label,
      promptTextBackground: theme.colors.agentBuilder?.promptTextBackground,
      accordionBackground: theme.colors.agentBuilder?.accordionBackground,
      accordionBackgroundHover: theme.colors.agentBuilder?.accordionBackgroundHover,
      accordionRowBackground: theme.colors.global?.lightBlueGray,
      selectedNode: {
        background: {
          main: theme.colors.agentBuilder?.selectedNodeBackground,
          hover: theme.colors.agentBuilder?.selectedNodeBackgroundHover,
          active: theme.colors.agentBuilder?.selectedNodeBackgroundActive,
        },
      },
    },
    agentChat: {
      lightGray: theme.colors.agentChat?.lightGray,
      secondaryGray: theme.colors.agentChat?.secondaryGray,
      mediumGray: theme.colors.agentChat?.mediumGray,
      darkGray: theme.colors.agentChat?.darkGray,
      infoBlue: theme.colors.agentChat?.infoBlue,
      alertRed: theme.colors.agentChat?.alertRed,
    },
    searchBar: {
      background: theme.colors.darkGray,
      border: theme.colors.lightGray,
    },
    teamsPage: {
      tabBackground: theme.colors.mediumGray,
      selectedTabBackground: theme.colors.dimWhite,
    },
    dataSecurity: {
      companyConfidential: {
        bg: '#070c7d', // Blue
        fg: '#fff',
      },
      nonCompanyConfidential: {
        bg: '#406f28', // Green
        fg: '#fff',
      },
      cui: {
        bg: '#502B85', // Purple, per the approved GCC banner spec (2026-07-14)
        fg: '#fff',
      },
    },
  }
}
